if(typeof BSS_B2B) {
  if(!window.location.pathname.includes("/products")) {
    setTimeout(() =>{
      BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false);
    }, 3000)
  }
}
